// extracted by mini-css-extract-plugin
export var arrows = "_4b-5";
export var decrementer = "_4b-9";
export var disabled = "_4b-3";
export var error = "_4b-1";
export var hiddenText = "_4b-a";
export var incrementer = "_4b-8";
export var input = "_4b-7";
export var inputWrapper = "_4b-0";
export var readonly = "_4b-2";
export var regular = "_4b-6";
export var small = "_4b-4";